import { lazy } from "react";
import { Navigate } from "react-router-dom";
import Login from "../../views/Login";
import ForgotPassword from '../../views/ForgotPassword'
import Logout from "../../views/logut";
const Dashboard = lazy(() => import("../../views/dashboard"));
const AccountSettings = lazy(() => import("../../views/account-settings"));
const HelpCenter = lazy(() => import("../../views/HelpCenter"));
//** Smart Lane
const ServiceDrive = lazy(() => import("../../views/SmartLane/ServiceDrive/index"));
const DealerWebsite = lazy(() => import("../../views/SmartLane/DealerWebsite/index"));
const VipDashboard = lazy(() => import("../../views/SmartLane/VipDashboard"));
const SmartLane = lazy(() => import("../../views/SmartLane/Dashboard"));
const SalesLaneDashboard = lazy(() => import("../../views/SmartLane/SalesLaneDashboard"));

//** Web Call Connect
const WCCDashboard = lazy(() => import("../../views/web-call-connect/Dashboard"));
const Calls = lazy(() => import("../../views/web-call-connect/Calls"));
const Schedule = lazy(() => import("../../views/web-call-connect/Schedule"));
const Agents = lazy(() => import("../../views/web-call-connect/Agents"));
const Teams = lazy(() => import("../../views/web-call-connect/Teams"));

//** Hub Features
const Events = lazy(() => import("../../views/HubFeatures/Events"));
const Links = lazy(() => import("../../views/HubFeatures/Links"));
const AnnouncementsGrid = lazy(() => import("../../views/HubFeatures/Announcement"));
// ** Pulse Point
const Dealerships = lazy(() => import("../../views/PulsePoint/Dealerships/index"));
const Roles = lazy(() => import("../../views/PulsePoint/Roles/index"));
const ActivityLog = lazy(() => import("../../views/activity-log/index"));
const Visitor = lazy(() => import("../../views/PulsePoint/Visitors/index"));
const LockedUsers = lazy(() => import("../../views/PulsePoint/LockedAccount/index"));
const BlockedVisitors = lazy(() => import("../../views/PulsePoint/BlockedVisitors/index"));
const SmarterDealerUsers = lazy(() => import("../../views/PulsePoint/SmarterDealerUsers/index"));
const DealershipUsers = lazy(() => import("../../views/PulsePoint/DealershipUsers/index"));
//wcc
const Wcc = lazy(() => import("../../views/wcc/index"));

const Routes = [
    { path: "/dashboard", element: <Dashboard />, abilityId: "dashboard", action: 'read', resource: "default" },
    { path: '/logout', element: <Logout />, abilityId: "logout", action: 'read', resource: "default" },
    { path: "/login", element: <Login />, meta: { layout: 'blank', publicRoute: true, restricted: true } },
    { path: "/forget-password", element: <ForgotPassword />, meta: { layout: 'blank', publicRoute: true, restricted: true } },
    
    /*************** SMART LANE ROUTES START ****************/
    { path: "/smart-lane/service-valuation", element: <SmartLane />, abilityId: "smart-lane-dashboard", action: 'read', resource: "smart-lane-dashboard" },
    // { path: "/smart-lane/service-drive", element: <ServiceDrive />, abilityId: "service-drive", action: 'read', resource: "service-drive" },
    // { path: "/smart-lane/dealer-website", element: <DealerWebsite />, abilityId: "dealer-website", action: 'read', resource: "dealer-website" },
    { path: "/smart-lane/vip-dashboard", element: <VipDashboard />, abilityId: "smart-lane-vip-dashboard", action: 'read', resource: "smart-lane-vip-dashboard" },
    { path: "/smart-lane/sales-lane-dashboard", element: <SalesLaneDashboard />, abilityId: "sales-lane-dashboard", action: 'read', resource: "sales-lane-dashboard" },
    /*************** SMART LANE ROUTES END ****************/

    /*************** WEB CALL CONNECT ROUTES START ****************/
     { path: "/wcc/dashboard", element: <WCCDashboard />, abilityId: "wcc-dashboard", action: 'read', resource: "wcc-dashboard" },
     { path: "/wcc/calls", element: <Calls />, abilityId: "wcc-calls", action: 'read', resource: "wcc-calls" },
    //  { path: "/wcc/schedule", element: <Schedule />, abilityId: "schedule", action: 'read', resource: "schedule" },
     { path: "/wcc/agents", element: <Agents />, abilityId: "wcc-agents", action: 'read', resource: "wcc-agents" },
     { path: "/wcc/teams", element: <Teams />, abilityId: "wcc-teams", action: 'read', resource: "wcc-teams" },
    /*************** WEB CALL CONNECT ROUTES END ****************/

    /*************** HUB FEATURES ROUTES START ****************/
    { path: "/hub-features/links", element: <Links />, abilityId: "links", action: 'read', resource: "links" },
    { path: "/hub-features/events", element: <Events />, abilityId: "events", action: 'read', resource: "events" },
    { path: "/hub-features/announcements", element: <AnnouncementsGrid />, abilityId: "announcements", action: 'read', resource: "announcements" },
    /*************** HUB FEATURES ROUTES END ****************/

    /*************** PULSE POINT ROUTES START ****************/
    { path: "/pulse-point/dealerships", element: <Dealerships />, abilityId: "dealerships", action: 'read', resource: ['dealerships', 'subdealership'] },
    { path: "/pulse-point/smarterDealer-users", element: <SmarterDealerUsers />, abilityId: "smarterDealer-users", action: 'read', resource: "smarterDealer-users" },
    { path: "/pulse-point/dealership-users", element: <DealershipUsers />, abilityId: "dealership-users", action: 'read', resource: "dealership-users" },
    { path: "/pulse-point/blocked-visitors", element: <BlockedVisitors />, abilityId: "blocked-visitors", action: 'read', resource: "blocked-visitors" },
    { path: "/pulse-point/locked-accounts", element: <LockedUsers />, abilityId: "locked-users", action: 'read', resource: "locked-accounts" },
    { path: "/pulse-point/visitors", element: <Visitor />, abilityId: "visitors", action: 'read', resource: "visitors" },
    { path: "/pulse-point/roles", element: <Roles />, abilityId: "roles", action: 'read', resource: "roles" },
    /*************** PULSE POINT ROUTES END ****************/

    /*************** ACTIVITY LOG ROUTES START ****************/
    { path: '/activity-log/dealerships', element: <ActivityLog />, action: 'read', resource: "activity-log" },
    { path: '/activity-log/users', element: <ActivityLog />, action: 'read', resource: "activity-log" },
    { path: '/activity-log/visitors', element: <ActivityLog />, action: 'read', resource: "activity-log" },
    /*************** ACTIVITY LOG ROUTES END ****************/

    /*************** ACCOUNT SETTING ROUTES START ****************/
    { path: '/account-settings', element: <AccountSettings />, action: 'read', resource: "default" },
    { path: '/help-center', element: <HelpCenter />, action: 'read', resource: "help-center" },

    // { path: '/WCC', element: <Wcc/>, action: 'read', resource: "WCC" },
    /*************** ACCOUNT SETTING ROUTES END ****************/
];

export { Routes };
